import React from 'react';
import { Utensils, Zap, Shirt, Pill, FileText, Sparkles } from 'lucide-react';
import { mockData } from '../mock';

const getSectorIcon = (name) => {
  if (name.includes('Food')) return <Utensils size={24} />;
  if (name.includes('Oil')) return <Zap size={24} />;
  if (name.includes('Textile')) return <Shirt size={24} />;
  if (name.includes('Pharmaceutical')) return <Pill size={24} />;
  if (name.includes('Paper')) return <FileText size={24} />;
  if (name.includes('Cosmetics')) return <Sparkles size={24} />;
  return <Utensils size={24} />;
};

export const Applications = () => {
  return (
    <section id="applications" className="applications-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1 text-center mb-4">
            {mockData.applications.title}
          </h2>
          <p className="body-large text-center mb-8" style={{maxWidth: '600px', margin: '0 auto 48px'}}>
            Our high-quality guar gum serves as a versatile solution across multiple industries, enhancing product performance and manufacturing efficiency.
          </p>
        </div>
        
        <div className="applications-grid">
          {mockData.applications.sectors.map((sector, index) => (
            <div key={index} className="application-card network-card">
              <div className="application-header">
                <div className="application-icon">
                  {getSectorIcon(sector.name)}
                </div>
                <h3 className="heading-3">{sector.name}</h3>
              </div>
              
              <p className="body-medium mb-6">{sector.description}</p>
              
              <div className="uses-section">
                <h4 className="uses-title">Key Applications:</h4>
                <div className="uses-grid">
                  {sector.uses.map((use, idx) => (
                    <div key={idx} className="use-item">
                      <div className="use-bullet"></div>
                      <span>{use}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="application-cta">
                {/* <button className="btn-secondary w-full">Learn More</button> */}
                <a
                className="btn-secondary w-full"
                 href="https://en.wikipedia.org/wiki/Guar_gum"
                 target="_blank"
                 rel="noopener noreferrer"
                 >
                  Learn More
                 </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Applications Styles
const styles = `
.applications-section {
  background: var(--bg-subtle);
  padding: var(--spacing-giant) 0;
}

.applications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--spacing-large);
}

.application-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.application-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.application-icon {
  background: white;
  padding: 12px;
  border-radius: 16px;
  color: var(--brand-dark);
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 69, 52, 0.1);
}

.uses-section {
  flex-grow: 1;
  margin-bottom: 24px;
}

.uses-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.uses-grid {
  display: grid;
  gap: 10px;
}

.use-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--text-secondary);
}

.use-bullet {
  width: 6px;
  height: 6px;
  background: var(--brand-dark);
  border-radius: 50%;
  flex-shrink: 0;
}

.application-cta {
  margin-top: auto;
}

@media (max-width: 1024px) {
  .applications-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: var(--spacing-medium);
  }
}

@media (max-width: 781px) {
  .applications-grid {
    grid-template-columns: 1fr;
    gap: var(--spacing-medium);
  }
  
  .application-header {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}